export const MONEY_STATE_LABELS = {
    unpaid: 'Unpaid',
    partly_paid: 'Partly paid',
    paid: 'Paid',
    overpaid: 'Overpaid',
};
/**
 * The quick cash filters of the Expenses list, applied by the server, any of
 * which matches: something overdue; something falling due from today through
 * the next 30 days (overdue is its own filter, so each matches the figure of
 * the same name); anything still owed; and settled.
 */
export const EXPENSE_CASH_FILTERS = ['overdue', 'due30', 'unpaid', 'paid'];
export const EXPENSE_CASH_FILTER_LABELS = {
    overdue: 'Overdue',
    due30: 'Due in 30 days',
    unpaid: 'Unpaid',
    paid: 'Paid',
};
/** How far ahead "Due in 30 days" looks. */
export const CASH_DUE_WINDOW_DAYS = 30;
//# sourceMappingURL=installment.js.map